export const PatternConstants = {
    pattern: {
        cnic: [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/],
        phone: [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
        mobile: [/[0-9]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
        mobileMask: [
            /[0-9]/,/\d/, /\d/, /\d/, '-', 
            /\d/, /\d/, '-',             
            /\d/, /\d/, /\d/, /\d/ ,/\d/,/\d/,/\d/            
],          
        license: [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, '#', /\d/, /\d/, /\d/],
        //email: '^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$',
        email: '([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+',
        url: '/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/',
        floatno: '[0-9]{2}\.[0-9]{2}',
        time:[/[0-9]/, /\d/ , ':',  /\d/, /\d/, ':', /\d/, /\d/]
    }

};



// WEBPACK FOOTER //
// ./src/app/shell/shared/pattern.constants.ts